
(() => {
  const packUrl = '/collections/build-your-pack';

  function showMinimumOrderPopup() {
    if (document.getElementById('sodastick-minimum-popup')) return;

    const overlay = document.createElement('div');
    overlay.id = 'sodastick-minimum-popup';
    overlay.style.cssText = `
      position:fixed;inset:0;z-index:99999;
      background:rgba(0,0,0,.55);
      display:flex;align-items:center;justify-content:center;
      padding:20px;
    `;

    overlay.innerHTML = `
      <div role="dialog" aria-modal="true"
           aria-labelledby="sodastick-popup-title"
           style="background:white;color:#333;border-radius:16px;
                  padding:32px 24px;max-width:420px;width:100%;
                  text-align:center;position:relative;
                  box-shadow:0 12px 40px rgba(0,0,0,.2)">

        <button type="button" data-close-popup
                aria-label="Close"
                style="position:absolute;right:14px;top:10px;
                       background:transparent!important;
                       border:none!important;
                       outline:none!important;
                       box-shadow:none!important;
                       appearance:none!important;
                       -webkit-appearance:none!important;
                       width:auto!important;
                       min-width:0!important;
                       height:auto!important;
                       min-height:0!important;
                       padding:8px!important;
                       margin:0!important;
                       color:#555!important;
                       font-size:26px;
                       font-weight:400;
                       line-height:1;
                       cursor:pointer;
                       border-radius:0!important;">×</button>

        <h2 id="sodastick-popup-title"
            style="font-size:24px;margin:8px 0 16px;color:#333">
          Minimum Order: 4 Tubes
        </h2>

        <p style="font-size:16px;line-height:1.6;margin-bottom:24px">
          SodaStick is sold in a minimum quantity of 4 tubes.
          Mix and match your favourite flavours.
        </p>

        <a href="${packUrl}"
           style="display:block;background:#000;color:#fff;
                  padding:15px;border-radius:9px;
                  text-decoration:none;font-size:16px">
          Choose Your Flavours →
        </a>
      </div>
    `;

    document.body.appendChild(overlay);

    const closeButton = overlay.querySelector('[data-close-popup]');
    closeButton.focus({ preventScroll: true });

    function close() {
      document.removeEventListener('keydown', onKeydown);
      overlay.remove();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    document.addEventListener('keydown', onKeydown);

    closeButton.addEventListener('click', close);

    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
  }

  // Capture clicks before the theme's Add to Cart handler.
  document.addEventListener('click', (event) => {
    const button = event.target.closest(
      'button.sodastick-single-tube'
    );

    if (!button || button.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showMinimumOrderPopup();
  }, true);
})();
